/**
 * 更新paypal支付
 **/
// function updatePaypal(params) {
//   paypal.Messages({
//     amount: params,
//     style: {
//       layout: "text",
//       logo: {
//         type: "primary"
//       },
//       text: {
//         color: "black",
//         size: 14
//       }
//     }
//   }).render('#is-paypal');
  
//   paypal.Buttons({
//     createOrder: function(data, actions) {
//         return actions.order.create({
//           purchase_units: [{
//             amount: {
//               value: params
//             }
//           }]
//         });
//       }
// }).render('#paypal-button-container');
// }

(() => {
  class t extends HTMLElement {
    constructor() {
      super(),
        this.main = this.closest("main-product"),
        this.addEventListener("change", this.onVariantChange)
    }
    onVariantChange() {
      this.updateOptions(),
        this.updateMasterId(),
        this.updateSelectInfo(),
        this.toggleAddButton(!0, "", !1),
        this.removeErrorMessage(),
        this.currentVariant ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.toggleThirdPartyBuyButton()) : (this.toggleAddButton(!0, "", !0),
          this.setUnavailable()
        )
    }
    updateOptions() {
      const t = Array.from(this.querySelectorAll("[data-options]"));
      this.options = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked).value)
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
    }
    updateMedia() {
      this.currentVariant && this.currentVariant.featured_media && this.main.thumbnailImageSlide(this.currentVariant.featured_media.id)
    }
    updateURL() {
      this.currentVariant && -1 !== location.pathname.indexOf("/products/") && window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id)
    }
    updateVariantInput() {
      document.querySelectorAll(`#product-form-${this.dataset.section},#product-form-installment`).forEach(t => {
        const e = t.querySelector('input[name="id"]');
        e.value = this.currentVariant.id,
          e.dispatchEvent(new Event("change", {
            bubbles: !0
          }))
      }
      )
    }
    async renderProductInfo() {
      const t = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=` + this.dataset.section
        , e = "price-" + this.dataset.section
        , a = document.getElementById(e);
      // updatePaypal(this.currentVariant.price / 100);
      this.source = await fetch(t).then(t => t.text()).then(t => (new DOMParser).parseFromString(t, "text/html").getElementById(e)),
        this.source && a && (a.innerHTML = this.source.innerHTML),
        document.getElementById("price-" + this.dataset.section).classList.remove("visibility-hidden"),
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
    }
    toggleAddButton(t = !0, e, a) {
      const r = document.getElementById("product-form-" + this.dataset.section).querySelector('[name="add"]')
        , s = document.getElementById("product-form-" + this.dataset.section).querySelector('[name="add"]').querySelector("span");
      r && (t ? (r.setAttribute("disabled", !0),
        e && (s.textContent = e)) : (r.removeAttribute("disabled"),
          s.textContent = window.variantStrings.addToCart))
    }
    setUnavailable() {
      const t = document.getElementById("product-form-" + this.dataset.section).querySelector('[name="add"]')
        , e = document.getElementById("product-form-" + this.dataset.section).querySelector('[name="add"]').querySelector("span");
      t && (e.textContent = window.variantStrings.unavailable,
        document.getElementById("price-" + this.dataset.section).classList.add("uk-hidden"))
    }
    getVariantData() {
      return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData
    }
    removeErrorMessage() {
      const t = this.closest("section");
      if (t) {
        const e = t.querySelector("product-form");
        e && e.handleErrorMessage()
      }
    }
    updateSelectInfo() {
      const t = window.Shopify || {}
        , { id: e, price: a, title: r } = this.currentVariant;
      t.selected_variant = Object.assign(t.selected_variant || {}, {
        value: a / 100,
        content_ids: [e.toString()],
        content_name: r
      })
    }

    // 更新第三方购买按钮的显示状态
    toggleThirdPartyBuyButton() {
      const btn = document.getElementById('js-thirdPartyBuyButton');
      if (!btn) return;
      if (this.currentVariant && this.currentVariant.available) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
      }
    }
  }
  customElements.define("variant-radios", t);
  class e extends HTMLElement {
    constructor() {
      super(),
      
        this.selectors = {
          slideshowElement: this.querySelector("[uk-slideshow]"),
          sliderElement: this.querySelector("[uk-slider]")
        },
        this.thumbnailImageClick();
      //   const p = JSON.parse(this.dataset.product);
      // paypal.Messages({
      //   amount: p.price,
      //   style: {
      //     layout: "text",
      //     logo: {
      //       type: "primary"
      //     },
      //     text: {
      //       color: "black",
      //       size: 14
      //     }
      //   }
      // }).render('#is-paypal');
    }
    thumbnailImageClick() {
      var t = UIkit.util.queryAll("[uk-slider] [data-index]");
      UIkit.util.on(t, "click", t => this.thumbnailImageSlide(t.target.dataset.thumbnailId))
    }
    thumbnailImageSlide(t) {
      var e = this.querySelector(`[data-media-id="${t}"]`);
      e && (UIkit.util.removeClass(UIkit.util.queryAll("[uk-slider] [data-thumbnail-id]"), "tm-active"),
        this.querySelector(`[data-thumbnail-id="${t}"]`).classList.add("tm-active"),
        UIkit.slideshow(this.selectors.slideshowElement).show(e.dataset.imageIndex),
        UIkit.slider(this.selectors.sliderElement).show(e.dataset.imageIndex))
    }
  }
  customElements.define("main-product", e);
  class a extends HTMLElement {
    constructor() {
      super(),
        this.form = this.querySelector("form"),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        this.cartOffcanvas = document.querySelector("header-cart-dropdown");
    }
    onSubmitHandler(t) {
      t.preventDefault(),
        this.handleErrorMessage();
      const e = this.querySelector('[type="submit"]')
        , a = (e.setAttribute("disabled", !0),
          e.classList.add("loading"),
        {
          method: 'POST'
        });
      a.body = new FormData(this.form);
      // try {
      //   qp("track", "AddToCart");
      //   mkq("track", "AddToCart", shopify.selected_variant);
      //   gtag("event", "add_to_cart");
      // } catch (t) { }
      fetch(routes.cart_add_url + ".js", a).then(t => t.json()).then(async t => {
        if (t.status)
          this.handleErrorMessage(t.description);
        else {
          var e = await this.getCartData();
          this.cartOffcanvas.renderContents(e),
            UIkit.offcanvas(this.cartOffcanvas).show();
          try {
            // affirm.ui.refresh()
          } catch (t) {
            console.error(t)
          }
        }
      }
      ).catch(t => {
        console.error(t),
          UIkit.offcanvas(this.cartOffcanvas).hide()
      }
      ).finally(() => {
        e.classList.remove("loading"),
          e.removeAttribute("disabled")
      }
      )
    }
    handleErrorMessage(t = !1) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector("[data-error-message-wrapper]") || null,
        this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector("[data-error-message]") || null,
          this.errorMessageWrapper && this.errorMessageWrapper.toggleAttribute("hidden", !t),
          t && this.errorMessage && (this.errorMessage.textContent = t))
    }
    async getCartData() {
      var t = JSON.stringify({
        sections: this.cartOffcanvas.getSectionsToRender().map(t => t.section),
        sections_url: window.location.pathname
      });
      return fetch("" + routes.cart_update_url, {
        ...Shopify.fetchConfig(),
        body: t
      }).then(t => t.text()).then(t => JSON.parse(t))
    }
  }
  customElements.define("product-form", a)
}
)();
